import "./site-settings.css";
import React from "react";
import useUserContext from "../../hooks/useUserContext";
import ShopManagers from "../../components/shopManagers/ShopManagers";
import BlackoutPeriods from "../../components/blackoutPeriods/BlackoutPeriods";
import PaymentsSection from "../../components/paymentsSection/PaymentsSection";
import {useLocation} from "react-router-dom";
import MoreConfigurationsSection from "../../components/moreConfigurationsSection/MoreConfigurationsSection";
import AccountSection from "../../components/accountSection/AccountSection";
import WhatsappProfileSection from "../../components/whatsappProfileEditor/WhatsappProfileSection";
import useAppContext from "../../hooks/useAppContext";
import ConsentIntegrationSection from "../../components/consentIntegrationSection/ConsentIntegrationSection";
import OtpManagerSettingsSection from "../../components/otpManager/OtpManagerSettingsSection";

const SiteSettings = () => {
    const { data: { shop, waba }} = useAppContext();
    const params = useLocation().search;
    const section = new URLSearchParams(params).get("section");
    // const paymentUpdateStatus = new URLSearchParams(params).get("payment_update_status");
    // const cap = new URLSearchParams(params).get("cap");
    const hasWaba = !!waba?.data?.waba?.providerSenderId;
    const hasPhone = !!waba?.data?.waba?.phoneId;

    return (
        <div className="site-settings-container">
            <div className="title">Site settings</div>
            <div className="subtitle">{shop.data?.friendlyName}</div>
            <PaymentsSection isInitiallyOpen={section === 'payments'} />
            {hasWaba ? <>
                {/*<PhoneSection isInitiallyOpen={section === 'phone'} />*/}
                {/*<TwilioWhatsappBusinessAccount isInitiallyOpen={section === 'meta'} />*/}
                <WhatsappProfileSection isInitiallyOpen={section === 'profile'} />
                <MoreConfigurationsSection isInitiallyOpen={section === 'configurations'} />
                <ConsentIntegrationSection isInitiallyOpen={section === 'consent-integration'} />
                <OtpManagerSettingsSection isInitiallyOpen={section === 'otp-settings'} />
                <ShopManagers isInitiallyOpen={section === 'managers'} />
                <BlackoutPeriods isInitiallyOpen={section === 'blackout'} />
            </> : null}
            <AccountSection isInitiallyOpen={section === 'account'} />
        </div>
    )
}

export default SiteSettings;